export default __webpack_public_path__ + "static/media/vid1.3b08071c.mp4";